import React, { useEffect, useRef, useState } from 'react'
import cogoToast from 'cogo-toast-react-17-fix';
import { Icon } from 'react-icons-kit';
import { basic_mail } from 'react-icons-kit/linea/basic_mail'


import API from '../../../../ApiConfig'
import { ADD_TO_CART, EMP_REQUEST_TO_ISSUER, SEND_REQUEST_VERIFICATION, SET_DRAFT_FORM_RECIEPIENT, UPLOAD_LOA } from '../../../../Utils/constant'
import { BUTTONS, MESSAGE } from '../../../../Utils/Strings';
import styles from '../Verifier/VerifyUsers.module.css';
import Modal from '../../../../Utils/Modal';
import { useNavigate } from 'react-router-dom';
import initiatePayment from '../../../../components/RazorPay/paymentGateway';
import useRazorpayPayment from '../../../../components/RazorPay/paymentGateway';
import { useDispatch, useSelector } from 'react-redux';
import { addItem } from '../../../../Utils/Redux/CartSlice';
import Loader from '../../../../components/Loader';
import AnimatedLoader from '../../../../components/AnimationLoader';
import CartPopupModel from '../../../Cart/CartPopupModel';


export default function DisplayResult({ result, documentData, fieldsData, setFieldsData, company, form_id, verifier_id, onbehalf, setresult, issuer_company, other_company_name, setShowPopup, ARSNo , recordFound, setIsRecordFound, templateData, setTemplateData, submitTrigger, setSubmitTrigger, formValid, setIsFormValid, templateId, employmentType}) {
    const [Popup, setPopup] = useState(false);
    const[LOAPopup, setLOAPopup]=useState(false);
    const [LOAargs, setLOAargs]=useState(null)
    
    const[loading, setLoading]=useState(false)
    
    
    const razorpay = useRazorpayPayment(verifier_id);
    const dispatch = useDispatch();
    // const cart_items = useSelector((state) => state.cart.items);

    const navigate = useNavigate();

    const [documentStatus, setDocumentStatus] = useState(result.map(obj => {
        const docId =  obj.master_document_id; // Extract document ID
        const requestSenttoIssuer = obj.request_to_issuer; // Extract true/false value
        const is_sent = obj.request_sent;
        const docName = obj.master_document_name
        const LOA_required=obj.LOA_required;
        const search_type=documentData.search_type
        const is_employment=obj.employment
        return { master_document_name: docName, requestSenttoIssuer, is_sent, master_document_id: docId, LOA_required, search_type, is_employment };
    }))

    useEffect(() => {
        setDocumentStatus(
            result.map(obj => {
                const docId = obj.master_document_id; // Extract document ID
                const requestSenttoIssuer = obj.request_to_issuer; // Extract true/false value
                const is_sent = obj.request_sent;
                const docName = obj.master_document_name
                const LOA_required=obj.LOA_required;
                const search_type=documentData.search_type;
                const is_employment=obj.employment
                return { master_document_name: docName, requestSenttoIssuer, is_sent, master_document_id: docId, LOA_required, search_type, is_employment };
            })
        )
    }, [result, documentData, fieldsData, company, templateData])
    
    
    const [droppedFileName, setDroppedFileName] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const[fileError, setFileError]=useState(null)
    const fileInputRef = useRef(null)
    const handleBoxClick = () => fileInputRef.current.click()

  const handleDragOver = (event) => {
    event.preventDefault();
  }
  const handleDrop = (event) => {
    event.preventDefault();
    // setDataInserted(false);
    const droppedFile = event.dataTransfer.files[0];

    if (droppedFile) {
      setSelectedFile(droppedFile);
      setDroppedFileName(droppedFile.name);
    }
  }
  const handleFileChange = async (e) => {
    e.preventDefault();
    // setDataInserted(false)
    const file = e.target.files[0];

    if (file) {
      setSelectedFile(file);
      setDroppedFileName(file.name);
    }
  }
  const updatePopup = (bool)=>{
    setLOAPopup(bool)
    setDroppedFileName(null)
    setSelectedFile(null)
  }
  const handleUpload=(docId, type)=>{
    if(selectedFile){
            request_issuer(docId, type)
        }
    else{
        setFileError(true)
    }
        
    }
    const UploadLOA=()=>{
            return(
    
                <div className={styles.modal_content}>
    
                    <h2>{issuer_company=="Walmart Global Technology Services India Private Limited"?"Upload Document":"Upload LOA"}</h2>
                    <AnimatedLoader isOpen={loading} loadingText={"Uploading..."}/>
                    <div
                        className={`${"fileUploadBox"} ${selectedFile ? "fileSelected" : ""}`}
                        onClick={handleBoxClick}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        style={{width:"inherit"}}
                      >
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                        {droppedFileName || selectedFile ? (
                          <div className="dragContent" style={{padding:"0 1rem"}}>
    
                          <p style={{ fontWeight: "600" }}>
                            Selected File: {droppedFileName || selectedFile.name}
                          </p>
                          </div>
                        ) : (
                          <div className="dragContent">
                            <img src="/uploadoutline.svg" alt="upload icon" />
                            <p style={{ fontWeight: "700" }}>
                              {issuer_company==="Walmart Global Technology Services India Private Limited"?"Upload Document with recipients' data from your computer":"Upload LOA with recipients' data from your computer"}
                            </p>
                            <p
                              style={{ color: "Gray" }}
                            >{`.pdf, .jpg, .jpeg, .png`}</p>
                          </div>
                        )}
                      </div>
                      {fileError && <p style={{color:"red"}}>Upload File First</p>}
                      <button className={styles.close + " " + styles.button + " " + styles.primarybutton} style={{cursor:"pointer"}}
                        onClick={() => handleUpload(LOAargs?.doc_id, LOAargs?.type)}>Upload</button>
                    <button className={styles.close + " " + styles.button} onClick={()=>updatePopup()}>{BUTTONS.CLOSE}</button>
                </div>
            )
        }

    const SendRequest = () => {
        return (
            <div className={styles.modal_content}>
                <div className={styles.circle}>
                    <Icon icon={basic_mail} size={'3rem'} />
                </div>

                <h2>Request Sent</h2>
                <p id={styles.request_description}>{MESSAGE.REQUEST_ACCESS}</p>
                <button className={styles.close + " " + styles.button}
                    onClick={() => navigate('/dashboard/emp/requests')}>View My Requests</button>
                <button className={styles.close + " " + styles.button + " " + styles.primarybutton}>{BUTTONS.CLOSE}</button>
            </div>
        )
    }

    const SubmitRequest = async (doc_id, type) => {
        // const response = await razorpay();
        // console.log(response)
        // if (response) {
        // if (type == 0) {
        //     request_holder(doc_id, type)
        // }
        // else {
        if(doc_id.LOA_required){
            handleLOA(doc_id, type)
        }
         else{    
        request_issuer(doc_id, type)
         }
        // }
        // setDocumentStatus(prevStatus =>
        //     prevStatus.map(doc =>
        //         doc.master_document_id === doc_id ? { ...doc, is_sent: true } : doc
        //     )
        // );
        // } else {
        //     cogoToast.error("Payment verification failed or canceled.");
        // }
    };

    // const request_holder = (doc_id, type) => {
    //     let parent_api_data = {
    //         form_id: form_id,
    //         name: fieldsData.find(field => field.field_name === "name")?.value,
    //         email: fieldsData.find(field => field.field_name === "email")?.value,
    //         phone_number: fieldsData.find(field => field.field_name === "phone_number")?.value
    //     }
    //     let APIData = {
    //         "verifier_id": verifier_id, // add verifier ID
    //         "form_id": form_id
    //     }
    //     API.post(SET_DRAFT_FORM_RECIEPIENT, parent_api_data)
    //         .then(res => {
    //             const verifier_request_id = res.data.data.id
    //             API.post(SEND_REQUEST_VERIFICATION, APIData)
    //                 .then(res => {
    //                     setPopup(true)
    //                     setDocumentStatus(prevStatus =>
    //                         prevStatus.map(doc =>
    //                             doc.master_document_id === doc_id ? { ...doc, is_sent: true } : doc
    //                         )
    //                     );
    //                     request_issuer(doc_id, type, verifier_request_id)
    //                 })
    //                 .catch(err => {
    //                     console.log(err)
    //                     cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
    //                 })
    //         })
    //         .catch(err => {
    //             console.log(err)
    //             let error = err.response.data.detail?.[0]
    //             try {
    //                 error = error.errors
    //                 const errorKeys = Object.keys(error)
    //                     .map(key => key.replace(/_/g, ' ')) // Replace underscores with spaces
    //                     .join(', ');
    //                 cogoToast.error(errorKeys + " are invalid")
    //             }
    //             catch (e) {
    //                 cogoToast.error(err.response.data.detail[0].error)
    //             }
    //         })
    // }

    useEffect(()=>{
        if(formValid==true){
            setLOAPopup(true)
            setIsFormValid(false)
        }
    },[formValid])

    const handleLOA=(doc_id, type)=>{
        setSubmitTrigger(prev=>!prev)
        setLOAargs({doc_id, type})

    }
    const request_issuer = (doc, type) => {
        setLoading(true)

        if (onbehalf.company_name=="OTHERS" && other_company_name.trim() === "") {
                    setLoading(false)
                    setLOAPopup(false)
                    cogoToast.info('Please Enter Other')
                    return
            }
        if (!company) {
                setLoading(false)
                setLOAPopup(false)
                cogoToast.info('Please Enter Issuer')
                return
        }
        else{
        let api_data=new FormData()
        api_data.append("verifier_id", String(Number(verifier_id)))
        api_data.append("issuer_company_id",Number(company.id))
        // api_data.append("form_id",Number(form_id))
        api_data.append("company_id", onbehalf ?Number(onbehalf.company_id) : null)
        api_data.append("master_document_id",Number(doc.master_document_id))
        api_data.append("notification_info_name",fieldsData.find(field => field.field_name === "name")?.value)
        api_data.append("notification_info_email",fieldsData.find(field => field.field_name === "email_id")?.value)
        api_data.append("notification_info_phone_number", fieldsData.find(field=>field.field_name==="phone_number")?.value)
        
        // if(doc.is_employment){
            // if(doc.search_type=="blue_collar"){
            //     api_data.append("aadhar_last_three_digits",fieldsData.find(field=>field.field_name==="aadhar_last_three_digits")?.value)
            //     api_data.append("pan_last_five_digits",fieldsData.find(field=>field.field_name==="pan_last_five_digits")?.value)
            //     api_data.append("date_of_birth", fieldsData.find(field=>field.field_name==="date_of_birth")?.value)
            //     api_data.append("search_type", doc.search_type)
            // }
            // else if(doc.search_type=="white_collar"){
                api_data.append("loa_file",selectedFile)
                api_data.append("search_type", "white_collar")
                api_data.append("employee_id",fieldsData.find(field=>field.field_name==="employee_id")?.value)
                api_data.append("other_company_name", other_company_name?other_company_name:null)
                if(company.name=="Walmart Global Technology Services India Private Limited"){
                    api_data.append("gts_id",fieldsData.find(field=>field?.field_name==="gts_id")?.value)
                }
                if(company.employment_type_enabled){
                    api_data.append("employment_type", employmentType)
                }
            // }
        // }
        // else{
        //     api_data.append("search_type","others")
        // }
        if(!recordFound){
            console.log("templateData", templateData)
            let prefillDocFields=templateData.map(item=>{
                if (item?.doc_field_id !== undefined && item?.doc_field_id !== null) {
                    return {
                        doc_field_id: item.doc_field_id,
                        value: item.value
                    }
                }
                return {
                    wa_master_field_id: item?.wa_master_field_id,
                    value: item.value
                }
            })
            api_data.append("prefilled_doc_fields",JSON.stringify(prefillDocFields))
            if (templateId) {
                api_data.append("master_template_id",templateId)
            }
        }
        if(ARSNo){
            api_data.append("ars_no", ARSNo)
        }
        for (let [key, value] of api_data.entries()) {
            console.log(`${key}:`, value);
          }
        
        API.post(ADD_TO_CART, api_data)
            .then(res => {
                setLoading(false)
                setLOAPopup(false)
                setDroppedFileName("")
                setSelectedFile(null)
                // console.log(res.data)
                let api_data = {
                    issuer_company_id: company.id,
                    form_id: form_id,
                    document_name: doc.master_document_name,
                    issuer_name: company.company_name,
                    master_document_id: doc.master_document_id,
                    holder_name: fieldsData.find(field => field.field_name === "name")?.value,
                    holder_email: fieldsData.find(field => field.field_name === "email_id")?.value,
                    holder_phone_number: fieldsData.find(field => field.field_name === "phone_number")?.value,
                    request_to: doc.requestSenttoIssuer == true ? 'Issuer' : 'Holder',
                    employee_id:fieldsData.find(field=>field.field_name==="employee_id")?.value,
                    // cost: 2.0
                }
                if(company.name=="Walmart Global Technology Services India Private Limited"){
                    api_data.gts_id=fieldsData.find(field=>field?.field_name==="gts_id")?.value
                }

                // const exists = cart_items.some(
                //     (item) =>
                //         item.issuer_name === api_data.issuer_name &&
                //         // item.holder_email === api_data.holder_email &&
                //         item.document_name === api_data.document_name &&
                //         item.emp_id===api_data.employee_id
                // );
                // if (!exists) {
                    setLoading(false)
                    dispatch(addItem(api_data));
                    resetForm()
                    setShowPopup(true)
                    setTimeout(() => {
                        setShowPopup(false);
                      }, 5000)
                    // cogoToast.info(MESSAGE.REQUEST_SENT)
                    // setTimeout(() => navigate('/dashboard/cart'), 1000)
                // }
                // else {
                //     setLoading(false)
                //     cogoToast.error(MESSAGE.COULD_NOT_ACTIVATE)
                // }
            }
            )
            .catch(err => {
                setLOAPopup(false)
                setLoading(false)
                cogoToast.error(err.response.data.message)
            })
        }
    }

    function resetForm() {
        setresult(null)
        setFieldsData(fieldsData.map(field => ({ ...field, value: "" })))
        setTemplateData(null)
        setIsRecordFound(true)
    }

    return (
        <section className={styles.searchBox} style={{ padding: '1rem' }} >
            <Loader isOpen={loading}/>
            {result.length>0?documentStatus.map(doc => {
                const isDisabled = doc.is_sent;
                const requestType = doc.requestSenttoIssuer;
                // const requestTarget = doc.status ? "Holder" : "Issuer";
                const requestTarget = doc?.LOA_required==true?"": (doc.requestSenttoIssuer==true ? "Issuer" : "Holder");
                const isLOARequired=doc?.LOA_required
                return (
                    <div key={doc.master_document_id}>
                        {issuer_company=="Walmart Global Technology Services India Private Limited" && <span><span style={{fontWeight:"700"}}>Note: </span><ul>
                            <li style={{marginBottom:"5px"}}>Upload only the Relieving Letter (RL) or Experience Letter (EL) of the candidate. LOA or Payslips will not be accepted.</li>
                            <li>Verification requests should be raised only after the candidate has completed Full & Final (F&F) and possesses the RL/EL. In case of non-completion of F&F, the request will be rejected without any refund of the paid amount.</li>
                            </ul></span>}
                        {/* <h2 className="topTitleBarText">{doc.master_document_name}</h2> */}
                        <h2 className="topTitleBarText">Upload the signed Letter of Authorization (LOA) from the candidate. 
                        This authorization is mandatory to proceed with verification.</h2>
                        {/* <button
                            className={isDisabled ? "btn disabled" : "btn btn-primary"}
                            onClick={() => !isDisabled && SubmitRequest(doc.master_document_id, requestType)}
                            disabled={isDisabled}
                        > */}
                        <button
                            className={isDisabled?"btn btn-secondary":"btn btn-primary"}
                            onClick={() => SubmitRequest(doc, requestType)}
                            disabled={isDisabled}
                        >{issuer_company=="Walmart Global Technology Services India Private Limited"?"Upload "+doc.master_document_name:isLOARequired? "Upload LOA": documentData.search_type==="blue_collar"?"Add to cart":
                            isDisabled ? `Request Sent to ${requestTarget}`:`${BUTTONS.SEND_REQUEST} to ${requestTarget}`}
                        </button>
                        {
                            isDisabled && <span>The Request has been Already Sent</span>
                        }
                    </div>
                );
            }):<div style={{color:"#1c64f2"}}>Company has never issue any document yet !!</div>}


            <Modal title={''} isOpen={Popup} onClose={setPopup}>
                <SendRequest />
            </Modal>

            {/* <div className='row'>
                <div className='col pl-1'>
                    <button className='btn btn-primary' onClick={e => setPopup(true)}>{BUTTONS.SEND_REQUEST}</button>
                    <button className='btn btn-primary' disabled={loading} onClick={validateData} style={{ width: "fit-content" }}>
                        {loading ? <BtnLoader label={BUTTONS.CONTINUE} /> : BUTTONS.CONTINUE}
                    </button>
                </div>
            </div > */}


            <Modal title={''} isOpen={LOAPopup} onClose={updatePopup} blockOutsideClick={true}>
                <UploadLOA/>
            </Modal>
        </section >
    )

}
